module.exports = __webpack_public_path__ + "img/slider.0e800bb.png";